import { React, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import PermitWizard from "./pages/PermitWizard";
import PermitDetail from "./pages/PermitDetail";
import PermitList from "./pages/PermitList";
import AdminMasterData from "./pages/AdminMasterData";
import Contractors from "./pages/Contractors";
import Redirect from "./pages/Redirect";
import Logout from "./pages/Logout";
import Footer from "./pages/Footer";
import { useAuth } from "./pages/AuthContext";
import Navbar from "./pages/Navigation";
import { appUrl, appName } from "./pages/app_props";

const routes = [
  {
    path: "/",
    element: <Redirect />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/permits",
    element: <PermitList />,
  },
  {
    path: "/permits/new",
    element: <PermitWizard />,
  },
  {
    path: "/permits/:id/edit",
    element: <PermitWizard />,
  },
  {
    path: "/permits/:id",
    element: <PermitDetail />,
  },
  {
    path: "/admin/master-data",
    element: <AdminMasterData />,
  },
  {
    path: "/admin/contractors",
    element: <Contractors />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
];

const RouteConfig = () => {
  const { user } = useAuth();

  // const { user } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if the user is available
    if (user) {
      if (user.authorities !== undefined) {
        if (user.authorities.length > 0) {
          sessionStorage.setItem("userInfo", JSON.stringify(user));
          setLoading(true);
        } else {
          setLoading(false);
        }
      }
    }
  }, []);

  if (!loading) {
    // If user or user.authority is not present, do not render Navbar
    return (
      <BrowserRouter
        basename={
          !appUrl.endsWith("vistaarintuitivesolution.com")
            ? "/" + appName
            : undefined
        }
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          {/* <Navbar /> */}
          <main style={{ flex: 1 }}>
            <Routes>
              {routes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              <Route path="/authorized" element={<Redirect />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    );
  }
  return (
    <BrowserRouter
      basename={
        !appUrl.endsWith("vistaarintuitivesolution.com")
          ? "/" + appName
          : undefined
      }
    >
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <Navbar />
        <main style={{ flex: 1 }}>
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
            <Route path="/authorized" element={<Redirect />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default RouteConfig;
